// extracted by mini-css-extract-plugin
export default {"root":"Orders_root__5H46Q","loadingWrap":"Orders_loadingWrap__JArDG","pagination":"Orders_pagination__X7GwD","prevBtn":"Orders_prevBtn__+BU2h","nextBtn":"Orders_nextBtn__kCcPx"};